import { defaultHttpClient } from '../../httpClient';
import {
  atomicRendererDataConverter,
  type ScreensReadResponse,
} from '../getScreens';
import type { IScreensLogging } from '../../types';

export const getProxyComponents = (data: {
  url: string;
  screenLogging?: IScreensLogging;
}) => {
  return defaultHttpClient
    .request<ScreensReadResponse>({ method: 'GET', url: `/api/v2/${data.url}` })
    .then(result => result.data)
    .then(response => {
      if (data.screenLogging) {
        return {
          ...response,
          logging: {
            analytics: {
              ...data.screenLogging.analytics,
              ...response.logging?.analytics,
            },
            ably_only_log: {
              ...data.screenLogging.ably_only_log,
              ...response.logging?.ably_only_log,
            },
          },
        };
      }
      return response;
    })
    .then(atomicRendererDataConverter);
};
